mainApp.component('keepAliveConfiguration', {
    templateUrl: '/public/components/configuration/failover/keep-alive-configuration.component.html',
    bindings: {
        config: "<?",
        onConfigChanged: "&?",
        path: "<?",
        defaults: "<",
        precedencesList: "<?",
        defaultLabel: "<",
    },
    controller: function($scope, $controller, FailoverConfigurationService) {
        const ctrl = this;
        _.merge(ctrl, $controller('BaseFailoverConfigController', {$scope: $scope, ctrl: ctrl,}));



        ctrl.monitorFrequencyItems = [{name: 'monitorFrequencyPrecedence1', label: 'Precedence 1', model: 'monitorFrequencyPrecedence1Value', requiredPrecedence: 1},
                                      {name: 'monitorFrequencyPrecedence2', label: 'Precedence 2', model: 'monitorFrequencyPrecedence2Value', requiredPrecedence: 2},
                                      {name: 'monitorFrequencyPrecedence3', label: 'Precedence 3', model: 'monitorFrequencyPrecedence3Value', requiredPrecedence: 3}];


        ctrl.updateDefaultsLabel = function() {
            if(!ctrl.labels) {
                ctrl.labels = {};
            }
            ctrl.labels.monitorFrequencyPrecedence1 = ctrl.defaultLabel + "(" + ctrl.defaults.monitorFrequencyPrecedence1Value + " sec)";
            ctrl.labels.monitorFrequencyPrecedence2 = ctrl.defaultLabel + "(" + ctrl.defaults.monitorFrequencyPrecedence2Value + " sec)";
            ctrl.labels.monitorFrequencyPrecedence3 = ctrl.defaultLabel + "(" + ctrl.defaults.monitorFrequencyPrecedence3Value + " sec)";
        }

        ctrl.isDisabled = function (requiredPrecedence) {
            return ctrl.precedencesList[requiredPrecedence] == undefined;
        }

    }
});